// Shared by the dashboard routes' elements, which are part of the app shell's
// bundle, and by their loader chunk, so this module must stay free of anything
// that reaches a page.

/**
 * Whether a dashboard key names a cost dashboard, which the console renders
 * with the cost views (behind DashboardProviderGuard) rather than the
 * compliance ones.
 */
export function isCostDashboardKey(key: string): boolean {
  return key.includes("cost");
}

/**
 * Whether a dashboard key names a CIS benchmark version. Those have a page of
 * their own (`/dashboards/cis`), which `/dashboards/:key` redirects to; only
 * their section details render under `/dashboards/:key`.
 */
export function isCisDashboardKey(key: string): boolean {
  return key.startsWith("cis-");
}
